<a class="btn btn-primary" (click)="generateCsv()">{{title}}</a>
